<template>
  <section class="vip">
    <za-banner></za-banner>
    <article class="article">
      <h1 class="article-title">会员权益——信息报告定制服务说明</h1>
      <h2 class="article-desc">会员年费：168元/年</h2>
      <section class="article-inner">
        <ul class="vip-list">
          <li v-for="(item, idx) in vipList" :key="idx">{{idx+1}}、{{item}}</li>
        </ul>
        <div class="notice">
          <p>注意：满足以下情况无法享受会员特权权益：</p>
          <ul class="notice-list">
            <li v-for="(item, idx) in notice" :key="idx">{{idx+1}}、{{item}}</li>
          </ul>
        </div>
      </section>
    </article>
  </section>
</template>

<script>
import zaBanner  from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  props: {},
  data () {
    return {  
      vipList: ['用户在支付一定会员服务费用后可享受本站会员服务。', 
      '会员有效期内可重复购买会员服务，购买成功后，同种类型会员服务有效期将在原有基础上顺延。',
      '以“年”为单位的会员服务，按照每年365天计算会员有效期。',
      '会员服务过期后，未购买的定制数据报告需要重新购买或续费会员后才能继续享受定制服务。'],
      notice: ['如若恶意注册、作弊阅读、盗用或冒用他人信息注册将被取消会员资格。']
    }
  }
}
</script>
<style scoped>
.article {
  width: 100%;
  padding: 50px 0 130px; 
}
.article-title, .article-desc {
  font-size: 36px;
  text-align: center;
}
.article-desc {
  margin: 64px 0;
}
.article-inner {
  width: 810px;
  margin: 0 auto;
  color: #666;
  line-height: 30px;
  font-size: 18px;
}
.notice {
  margin-top: 64px;
}
</style>